import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { IJobBoardSaveDTO, saveJobBoard } from 'wisestep-api';
import { ControlledTextInput, WsButton, WsDrawer, WsTypoColors, WsTypography } from 'wisestep-base';
import { object, string } from 'yup';

import { failed, success } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';
import { publishJobBoardValues, publishEmailValues } from '../helper/jobBoardHelper';

const validationSchema = object().shape({
  username: string().required('Username is required'),
  password: string()
    .min(4, 'Password must be at least 4 characters')
    .required('Password is required'),
});

export interface drawerProps {
  jobBoardName: string;
  openDrawer: boolean;
  onClose(): void;
}

const PublishAddAccountDrawer = ({ jobBoardName, openDrawer, onClose }: drawerProps) => {
  const jobBoardSave: IJobBoardSaveDTO = {
    jobBoard: publishJobBoardValues,
    email: publishEmailValues,
  };
  const setNotification = useNotificationStore((state) => state.setNotification);

  const formOptions = {
    resolver: yupResolver(validationSchema),
  };

  const methods = useForm(formOptions);
  const { handleSubmit } = methods;

  const onFormSubmit = async (data: FieldValues) => {
    try {
      publishJobBoardValues.username = data.username;
      publishJobBoardValues.password = data.password;
      publishJobBoardValues.jobBoardName = jobBoardName;
      if (jobBoardName == 'CWJobs')
        publishJobBoardValues.jobBoardSettings = JSON.stringify({
          feedId: data.feedId,
        });
      jobBoardSave.jobBoard = publishJobBoardValues;
      await saveJobBoard(jobBoardSave);
      setNotification(success(`Added Account successfully `));
      onClose();
    } catch {
      setNotification(failed('Failed to add account, Please try again !! '));
    }
  };

  return (
    <WsDrawer
      size="small"
      position="right"
      iconType="arrow"
      open={openDrawer}
      onClose={onClose}
      title={`Add new ${jobBoardName} account`}
      headerSize="medium"
    >
      <Grid container component="form">
        <Grid item xs={12} pl={4} pt={5}>
          <WsTypography color={WsTypoColors.SECONDARY}>
            {` Add account by configuring ${jobBoardName} account using RTP credentials. `}
          </WsTypography>
        </Grid>
        <FormProvider {...methods}>
          <Grid item xs={10} pt={4} pl={4}>
            <ControlledTextInput
              name="username"
              labelText="Username*"
              type="name"
              fullWidth
              id="outlined-basic"
              placeholder="Enter username"
              variant="outlined"
              required
              autoComplete="name"
            />
          </Grid>
          <Grid item xs={10} pt={4} pl={4}>
            <ControlledTextInput
              name="password"
              labelText="Password*"
              type="password"
              fullWidth
              id="outlined-basic"
              placeholder="Enter password"
              variant="outlined"
              required
              autoComplete="password"
            />
          </Grid>
          {jobBoardName == 'CWJobs' && (
            <Grid item xs={10} pt={4} pl={4}>
              <ControlledTextInput
                name="feedId"
                labelText="Feed Id*"
                type="text"
                fullWidth
                id="outlined-basic"
                placeholder="Enter Feed Id"
                variant="outlined"
                required
              />
            </Grid>
          )}
        </FormProvider>
        <Grid item xs={12} pl={4} pt={5}>
          <WsButton
            variant="contained"
            size="large"
            type="submit"
            onClick={handleSubmit(onFormSubmit)}
          >
            Continue
          </WsButton>
        </Grid>
      </Grid>
    </WsDrawer>
  );
};

export default PublishAddAccountDrawer;
